export default __webpack_public_path__ + "static/media/bread-bg2.99ebe153.jpg";